//SECTION Import Section
import React, { useEffect, useState, useCallback, useRef } from "react";
import GrapesJS from "grapesjs";
import "grapesjs/dist/css/grapes.min.css";
import ckplugin from "grapesjs-plugin-ckeditor";
// import "antd/dist/antd.min.css";
import grapesjsMJML from "grapesjs-mjml";
import newsletter from "grapesjs-preset-newsletter";
import webpage from "grapesjs-preset-webpage";
import { getToken } from "../../Utils/Common";
import "font-awesome/css/font-awesome.min.css";
import "../styles.css";
import { getAllAssetsNoLimit, testTemplate } from "api/TemaplateApi";
import { getLabels } from "api/AccountsApi";
import "bootstrap";
import { uploadAsset, saveTemplate } from "api/TemaplateApi";
import { toast } from "react-toastify";
import SelectArticles from "components/Vestorly/SelectArticles";
import { useSelector, useDispatch } from "react-redux";
import {
  setTemplateParameterId,
  setTemplateId,
  resetTemplateData,
  
} from "ReduxStore/Slices/templateSlice";
import { setisNewCampaignTempateId,setCampaignIsAdvisor , setCategory} from "ReduxStore/Slices/campaignSlice";
import { offersFlow } from '../../components/templateFlows/Offers'

import {postCampaignData} from 'api/CampaignApi'
import plugin from 'grapesjs-tui-image-editor';

import $ from 'jquery'
// const campaignData = useSelector((state) => state.campaignSetter);


let currentAddedBlock;
let type;
function getCurrentBlock() {
  return currentAddedBlock;
}
function getType() {
  return type;
}

//!SECTION

// SECTION GrapesJs Editor

// ANCHOR SpreadArray
var __spreadArrays =
  (this && this.__spreadArrays) ||
  function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++)
      s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
        r[k] = a[j];
    return r;
  };
var lastValue = "";
function myfun1(e) {
  var x = document.getElementById("ID");
  if (x) {
    x = x.value;
  } else {
    return;
  }
  // if (x == lastValue) return;
  lastValue = x;
  navigator.clipboard.writeText(x);

  if (x) {
    //  alert("the placeholder is copied");
    try {
      document.getElementById("mydiv").style.visibility = "visible";
      setTimeout(() => {
        try {
          document.getElementById("mydiv").style.visibility = "hidden";
        } catch (ee) { }
      }, 1500);
    } catch (e) { }
  }
}

// ANCHOR Preset
var presets = {
  webpage: webpage,
  newsletter: newsletter,
  grapesjsMJML: grapesjsMJML,
};
var ckpresets = {
  grapesjsMJML: ckplugin,

};
var imagePresets = {
   webpage: plugin,
  newsletter: plugin,
  grapesjsMJML: plugin,

}
// ANCHOR Editor Init
var Editor = React.forwardRef(function (props, ref) {
  type = props.presetType;
  // ANCHOR Init props
  var onInit = props.onInit,
    id = props.id,
    blockManager = props.blockManager,
    styleManager = props.styleManager,
    storageManager = props.storageManager,
    width = props.width,
    height = props.height,
    propPlugins = props.plugins,
    presetType = props.presetType,
    children = props.children,
    onDestroy = props.onDestroy,
    assetManager = props.assetManager;
  var _a = React.useState(null),
    editor = _a[0],
    setEditor = _a[1];
  const userData = useSelector((state) => state.userData);
  const templateData = useSelector((state) => state.templateSetter);
  const dispatch = useDispatch();



  // SECTION UseEffect
  useEffect(() => {

    // ANCHOR Asset images from API
    var interval = setInterval(function () {
      var x = document.getElementById("gjs-am-title");
      if (x != null) {
        document.getElementById("gjs-am-title").innerHTML =
          "Click here to upload image";
        clearInterval(interval);
      }

    }, 1);
    let editor = GrapesJS.init({
      container: "#" + id,
      fromElement: true,
      blockManager: blockManager,
      styleManager: styleManager,
      storageManager: storageManager,
      autorender: true,
      allowScripts: 1,
      assetManager: {
        // SECTION Upload asset File
        uploadFile:
          templateData.isContentFlag == false &&
          function (e) {
            let file = e.target.files[0];
            var formData = new FormData();
            formData.append("file", file);
            uploadAsset(formData)
              .then((data) => {
                editor.AssetManager.add(data.url);
              })
              .catch(function (response) {
                //handle error

              });
          },
        // !SECTION
      },

      width: width,
      
      height: height,
      plugins: __spreadArrays([presets[presetType]], [ckpresets[presetType] ,[imagePresets[presetType]] ,['grapesjs-tui-image-editor'] ]),
      pluginsOpts: {

 [plugin]: { /* options */ },


        [ckplugin]: {
position: "right",
          options: {
            startupFocus: true,
position: "right",
		
            extraAllowedContent: "*(*);*{*}", // Allows any class and any inline style
            allowedContent: true, // Disable auto-formatting, class removing, etc.
            extraPlugins:
              "justify,colorbutton,basicstyles,colordialog,button,panelbutton,font,format,image,indent,justify,language,link,pastetext,preview,save,undo",

          },
        },
      },
    });
    // editor.store()


    try {
      editor.on("rte:enable", () => {
        editor.trigger("canvasScroll");
      });
      const am = editor.AssetManager;
      const pn = editor.Panels;
      const commands = editor.Commands;
      const bm = editor.BlockManager;

      editor.on("load", function () {
        // alert("load")
        props.from_campaign
          ? pn.addButton("devices-c", {
            id: "save_btm",
            className: "editor_btn",
            active: false,
            label: "Continue",
            command: "campaignCommand",
          })
          : templateData.isContentFlag == false
            ? pn.addButton("devices-c", {
              id: "save_btm",
              className: "editor_btn",
              active: false,
              label: "Save & Exit",
              command: "templateCommand",
            })
            : pn.addButton("devices-c", {
              id: "save_btm",
              className: "editor_btn",
              active: false,
              label: "Exit",
              command: "exitToContent",
            });
        editor.store();
      })

      /////////////////////////////////////////////////////
      // *   OFFERS  SECTION    ////  
      ///
      ///   remove  blocks
      var url_string = window.location.href;
      var url = new URL(url_string);
      var flowType = url.searchParams.get("flow");




      if (props.isOffer || flowType == 'offers') {
        offersFlow(props.isOffer, flowType, editor, bm)
      }
      ////////////////////////////////////////////////////////////////////////////

      // bm.render(filtered);
      // bm.remove(filtered)

      ////////////////////////

      // !SECTION
      commands.add("campaignCommand", {
        run(editor, sender) {
          editor.on("change:changesCount", (e) => {
            editor.store();
            props.nexturl();
            dispatch(setisNewCampaignTempateId(false));
          });
          props.nexturl();
          dispatch(setisNewCampaignTempateId(false));
        },
        stop(editor, sender) { },
      });

      commands.add("templateCommand", {
        run(editor, sender) {
          editor.store();
          props.nexturl();
        },
        stop(editor, sender) { },
      });

      commands.add("exitToContent", {
        run(editor) {
          props.toContent();
          dispatch(resetTemplateData());
        },
      });
      // SECTION Exit button
      {


        if (
          props.templateType === "email" &&
          props.userFlow !== "createCampaign" &&
          templateData.isContentFlag == false
        ) {
          pn.addButton("views", {
            id: "testMail",
            className: "editor_btn",
            active: false,
            label: "Test Email",
            command: "testEmail",
          });
        }
      }
      editor.DomComponents.addType("vistorly", {
        isComponent: (el) => el.classList && el.classList.contains("oo"),
        onRender({ el }) {
          const btn = document.createElement("h1");
          btn.innerHTML = "kkkkkkkkkkkkkkkk";
          // This is just an example, AVOID adding events on inner elements,
          // use `events` for these cases
          btn.addEventListener("click", () => { });
          el.appendChild(btn);
        },
        model: {
          defaults: {
            tagName: "div",
            draggable: true, // Can be dropped only inside `form` elements
            droppable: true, // Can't drop other elements inside
            badgable: true,
            copyable: true,
            editable: true,
            selectable: true,
            attributes: {
              // Default attributes
              type: "text",
              name: "default-name",
              placeholder: "Insert wow here",
              innerHTML: "ggg",
            },
            components: `
            <div class='oo'>
             y
        </div>
      `,
            traits: [
              "name",
              "placeholder",
              { type: "checkbox", name: "required" },
            ],
          },
        },
      });



      if (props.isOffer || flowType == 'offers') {

      }

      var selector = editor.SelectorManager.add("vestorlyClass");
      var rule = editor.CssComposer.add(selector);
      rule.set("style", {
        color: "red",
        height: "290",
      });

      // bm.add('ImageExtended').set({
      //   label: 'Image Extended',
      //   category: 'Layout',
      //   attributes: { class: 'fa fa-image' },
      //   content: {
      //     type: 'image-extended',
      //     classes: ['img-extended'],
      //   },
      // });


      // bm.add("Vestorly").set({
      //   category: {
      //     label: 'App',
      //     order: 1,
      //   },
      //   label: "",
      //   attributes: { id: "vestorlyBlock" },
      //   content: `<mj-section id="vestorlyID" ></mj-section>`,
      // });

      // add categories to mjml blocks
      if (getType() != "webpage") {
        /****    uncomment to add vestorlyBlock     */
        if (!props.isOffer && flowType != 'offers') {
          bm.add("Vestorly").set({
            category: {
              label: "Basic",
              order: 1,
            },
            label: "",
            attributes: { id: "vestorlyBlock" },
            content: `<mj-section id="vestorlyID" ></mj-section>`,
          });
        }
        /****   */
        const basicCategory = {
          label: "Basic",
          order: 0,
        };
        const extraCategory = {
          label: "Extra",
          order: 2,
        };
        const socialCategory = {
          label: "Social",
          order: 3,
        };
        bm.get("mj-1-column").set({ category: basicCategory });
        bm.get("mj-2-columns").set({ category: basicCategory });
        bm.get("mj-3-columns").set({ category: basicCategory });
        bm.get("mj-text").set({ category: basicCategory });
        bm.get("mj-button").set({ category: basicCategory });
        bm.get("mj-image").set({ category: basicCategory });
        bm.get("mj-divider").set({ category: basicCategory });
        bm.get("mj-spacer").set({ category: basicCategory });
        bm.get("mj-navbar").set({ category: extraCategory });
        bm.get("mj-hero").set({ category: extraCategory });
        bm.get("mj-navbar-link").set({ category: extraCategory });
        bm.get("mj-wrapper").set({ category: extraCategory });
        bm.get("mj-raw").set({ category: extraCategory });
        bm.get("mj-social-group").set({ category: socialCategory });
        bm.get("mj-social-element").set({ category: socialCategory });
        bm.get("mj-social-group").set({ category: socialCategory });
      } else {
        const basicCategory = {
          label: "Basic",
          order: 0,
        };
        const extraCategory = {
          label: "Extra",
          order: 2,
        };
        const formsCategory = {
          label: "Forms",
          order: 3,
        };
        const blocks = bm.getAll();
        blocks.forEach((b) => {

          if (b.attributes.category == "Basic") {
            b.attributes.category = basicCategory;
          } else if (b.attributes.category == "Extra") {
            b.attributes.category = extraCategory;
          } else {
            b.attributes.category = formsCategory;
          }
        });
        if (!props.isOffer && flowType != 'offers') {
          /****    uncomment to add vestorlyBlock     */

          bm.add("Vestorly").set({
            category: {
              label: "Basic",
              order: 1,
            },
            label: "",
            attributes: { id: "vestorlyBlock" },
            content: `<mj-section id="vestorlyID" ></mj-section>`,
          });
          /*** */
        }
      }
      editor.on("component:add", (block) => {
        if (block.toHTML() == '<img style="width:0;height:0;" >')
          return


        if (block.toHTML() == '<mj-section id="vestorlyID"></mj-section>') {

          currentAddedBlock = block;

          if (document.getElementById("vestorlyWindow")) {
            document.getElementById("vestorlyWindow").style.display = "block";
            document.getElementById("cover").style.display = "block";
          }
        }
      });
      editor.on("component:selected", (model) => {
      let code = editor.getSelected().toHTML();
    });
  editor.on("load", () => {
    pn.getButton("views", "open-blocks").set("active", true);
  });

  editor.on("asset:open", () => {
    getAllAssetsNoLimit()
      .then((data) => {
        data.reverse();
        data.map((urls) => {
          am.add({ src: urls.url, name: urls.name });
        });
      })
      .catch((e) => { })
      })

  editor.on('canvas:drop', (model) => {


  })



  //Fixing mj-image close tag issue
  editor.DomComponents.addType("mj-image", {
    model: {
      defaults: {
        void: false,
      },
    },
  });

  var ddvalues = props.Dropdownvalues;
  sessionStorage.setItem("ddvalues", JSON.stringify(ddvalues));
  editor.RichTextEditor.add("custom-vars", {
    icon: `<select class="gjs-field" style="color: white">
                  ${ddvalues &&
      ddvalues.map((data, index) => {
        var label = data.label;
        var value = "{{" + String(data.value) + "}}";
        return `<option key=${index} value="${value}">
                        ${label}
                      </option>`;
      })
      }
                </select>`,
    event: "change",
    result: (rte, action) => {
      rte.insertHTML(action.btn.firstChild.value);
    },
    update: (rte, action) => {
      action.btn.firstChild.value = "";
    },
  });
  var x = "";
  var dd = ddvalues;

  if (ddvalues) {
    dd.map((data, index) => {
      var label = data.label;
      var value = "{{" + String(data.value) + "}}";

      x += `<option key=${index} value="${value}">
                        ${label}
                      </option>`;
    });
    setTimeout(function () { }, 20000);
  }

  function testApi() {
    testTemplate(props.templateParameterId)
      .then((res) => {
        toast.success(
          "A test email has been sent, please check your inbox!"
        );
      })
      .catch((e) => { })
      }

  commands.add("testEmail", {
    run(editor) {
      testApi();
    },
  });

  function getMjmlSocialOccurrence(x) {
    var t = '<mj-social-elementname="';
    var len = t.length;
    var all = [];
    var counter = 0;
    var start = -1;
    [...x].forEach((i, ind) => {
      if (i == t.charAt(counter)) {
        if (start == -1) start = ind;
        counter++;
      } else if (i != " ") {
        counter = 0;
        start = -1;
      }
      if (counter == len - 1) {
        var ggg = 0;
        var end = 0;
        for (var g = ind + 1; g < x.length; g++) {
          if (x.charAt(g) == '"') {
            ggg++;
            if (ggg == 2) {
              end = g;
              break;
            }
          }
        }
        if (ggg == 2) {
          if (!x.substring(start, end + 1).includes("-noshare")) {
            var pair = { a: start, b: end };

            all.push(pair);
          }
        }
      }
    });
    return all;
  }

  function replaceSharing(x, all) {
    var y = "";

    if (all != undefined && all.length > 0 && all != []) {
      y += x.substring(0, all[0].a);

      all.forEach((i, ind) => {
        var e;
        if (ind == all.length - 1) {
          e = x.length - 1;
        } else {
          e = all[ind + 1].a + 1;
        }

        var temp = x.substring(i.a, i.b + 1);
        if (temp.includes("facebook") && !temp.includes("-noshare")) {
          temp = temp.replace("facebook", "facebook-noshare");
        } else if (temp.includes("twitter") && !temp.includes("-noshare")) {
          temp = temp.replace("twitter", "twitter-noshare");
        } else if (temp.includes("google") && !temp.includes("-noshare")) {
          temp = temp.replace("google", "google-noshare");
        } else if (
          temp.includes("pinterest") &&
          !temp.includes("-noshare")
        ) {
          temp = temp.replace("pinterest", "pinterest-noshare");
        } else if (
          temp.includes("linkedin") &&
          !temp.includes("-noshare")
        ) {
          temp = temp.replace("linkedin", "linkedin-noshare");
        }
        y += temp + x.substring(i.b + 1, e);
      });
    }
    return y;
  }

  var codeViewer = editor.CodeManager.getViewer("CodeMirror").clone();

  codeViewer.set({
    codeName: "htmlmixed",
    readOnly: 0,
    theme: "hopscotch",
    autoBeautify: true,
    autoCloseTags: true,
    autoCloseBrackets: true,
    lineWrapping: true,
    styleActiveLine: true,
    smartIndent: true,
    indentWithTabs: true,
  });
  const deleteBlock = (b) => {
    b.replaceWith('')
    //setTimeout(()=>{b.replaceWith('')}, 2000);
  }


  ////////////
  /// handling change in style  (editor is faulty in this regard )
  let QUEUE =  []
  editor.on('component:styleUpdate', (model) => { 
    QUEUE.push({message:"save"})
   });
   setInterval(()=>{
    if(QUEUE.length){
      QUEUE = []
      editor.store();
    }
   },500)

   ///////////////////////////////////////////


  

  editor.on("storage:end:load", (resultObject) => {
    // try {
    //   document.getElementById("grapesjs-react-editor").style.height =
    //     "126vh";
    // } catch (e) { }
    if (
      (props.templateType === "email" &&
        !props.userFlow === "createCampaign") ||
      (props.campaignType === "email" &&
        props.userFlow === "createCampaign") ||
      (props.templateType === "email" && props.templateType === "email")
    ) {
      setTimeout(function () {


        let stylesDiv =  document.querySelector('.gjs-pn-panel.gjs-pn-views-container.gjs-one-bg.gjs-two-color').firstChild;
        stylesDiv.style.height = 'calc(100vh - 60px)';
        stylesDiv.style.position= 'fixed';
        stylesDiv.style.left = '60px';
        stylesDiv.style.top = '60px';
        stylesDiv.style.width = '200px';
        stylesDiv.style.backgroundColor = '#FFF';
        stylesDiv.style.paddingTop = '45px';
        stylesDiv.style.color = '#000'; 
        
        // set overflow
        stylesDiv.style.overflow = 'auto';

        stylesDiv.firstChild.id = 'myStyles_editor_hhhhsw'; 




        let div = document.createElement("div");
        div.innerHTML = `<span class='sps' id='myspan' '><select id ='ID' > <option key='-1' value=''>Personalize</option> ${x} </select></span>`;
        if(document.getElementsByClassName("gjs-pn-buttons")[1]?.firstChild?.firstChild?.classList[0] == 'sps'  )
          return;


        document
          .getElementsByClassName("gjs-pn-buttons")[1]
          .insertBefore(
            div,
            document.getElementsByClassName("gjs-pn-buttons")[1].firstChild
          );

        if (ddvalues) {
          dd.map((data, index) => {
            var label = data.label;
            var value = "{{" + String(data.value) + "}}";

            var tt = `<option key=${index} value="${value}">
                        ${label}
                      </option>`;

            let op = document.createElement("option");
            op.innerText = label;
            op.value = value;
            document.getElementById("ID").appendChild(op);
          });
        }

        document.addEventListener("change", myfun1);
      }, 1000);
    }

    if (sessionStorage.getItem("loadCounter") == "1") {

      var x = editor.getHtml();

      var aaa = getMjmlSocialOccurrence(x);
      if (aaa.length > 0) {
        x = replaceSharing(x, aaa);
        editor.setComponents(x);
      }
      var flag = 0;
      editor.on("component:add", async (e, arg) => {
        if (e.toHTML() == '<img style="width:0;height:0;" >')
          return
        if (flag % 2 != 0) {
        } else {
          if (e.attributes.tagName == "mj-social-element") {
            setTimeout(function () {
              var x = editor.getHtml();

              var aaa = getMjmlSocialOccurrence(x);
              if (aaa.length > 0) {
                x = replaceSharing(x, aaa);
                editor.setComponents(x);
              }
            }, 1);
          }

          var code = "";
          if (codeViewer.editor != undefined) {
            code = codeViewer.editor.getValue();
          }
          if (codeViewer.editor != null || codeViewer.editor != undefined) {
          }
        }
      });
      editor.on("component:update", async (e, arg) => {
        if (flag % 2 != 0) {
        } else {
          if (e.attributes.tagName == "mj-social-element") {
            setTimeout(function () {
              var x = editor.getHtml();

              var aaa = getMjmlSocialOccurrence(x);
              if (aaa.length > 0) {
                x = replaceSharing(x, aaa);
                editor.setComponents(x);
              }
            }, 1);
          }
        }
      });



    }
    sessionStorage.setItem("loadCounter", "1");
  });

  if (typeof onInit === "function") {
    onInit(editor);
  }
  setEditor(editor);
  return function cleanup() {
    if (editor) {
      if (typeof onDestroy === "function") {
        onDestroy(editor);
      }
      GrapesJS.editors = GrapesJS.editors.filter(function (e) {
        return e !== editor;
      });
      editor.destroy();
      if (document) {
        var container = document.getElementById(id);
        if (container) {
          container.innerHTML = "";
        }
      }
    }
  };
} catch (e) {

}
  }, [blockManager, height, id, onDestroy, onInit, presetType, propPlugins, storageManager, styleManager, width]);

React.useImperativeHandle(ref, function () {
  return editor;
});
return React.createElement("div", { id: id }, children);
});
Editor.defaultProps = {
  id: "grapesjs-react-editor",
  presetType: "",
  plugins: [],
  blocks: [],
  blockManager: {},
  storageManager: {},
  styleManager: {},
  width: "auto",
  height: "100vh",
  components: [],
};

function CreateTemplate(props) {
  const [emailtype, setemailtype] = useState();
  const [dropdownvalues, setDropdownvalues] = useState();
  const [urlLoad, setUrlLoad] = useState("");
  const [urlStore, setUrlStore] = useState("");
  const campaignData = useSelector((state) => state.campaignSetter);
  const {
    templateName,
    templateType,
    templateDescription,
    templateId,
    templateParameterId,
    backFromAllTemplates,
    isContentFlag,
    baseTemplateId,
    isOffer
  } = useSelector((state) => state.templateSetter);
  const userData = useSelector((state) => state.userSetter);
  const dispatch = useDispatch();
  const ref = useRef(null)

  const token = "Bearer " + getToken();

  useEffect(() => {
    if (templateParameterId !== null) {
      dispatch(setTemplateParameterId(templateParameterId));
    }
    getLabels()
      .then((data) => {
        let i = 0;
        let col = [];
        data.map((column) => {
          i++;
          if (column.isBaseSchema == false) {
            col.push({
              value: column.label,
              label: column.label,
              key: column.key,
            });
          }
          if (data.length === i) {
            setDropdownvalues(col);
          }
        });
      })
      .catch(function (error) {

      });

    const temourlload = urlToLoad();
    setUrlLoad(temourlload);
    const tempurlstore = urlToStore();
    setUrlStore(tempurlstore);


  }, [templateType]);

  const urlToLoad = () => {
    const campaignId = campaignData.currentABTestCampaign == 'A' ? campaignData.campaignId : campaignData.campaingABTestData.campaignABTestId;
    const campaignTemplateId = campaignData.currentABTestCampaign == 'A' ? campaignData.campignTemplateId : campaignData.campaingABTestData.campaignABTestTemplateId;
    if (userData.userFlow == "createCampaign") {
      //If we dont change the template while editing the campaign (While clicking on Continue editing)
      if (!campaignData.isNewCampaignTempateId) {
        return (
          process.env.REACT_APP_API_BASE_URL +
          `personal/campaigns/${campaignId}`
        );
      }
      //Whenever we select a new tempate for campaign
      else {
        return (
          process.env.REACT_APP_API_BASE_URL +
          `personal/templates/${campaignTemplateId}?campaignId=${campaignId}`
        );
      }
    }
    //If the userFlow is Template creation or editing load the template using this url
    else {
      return (
        process.env.REACT_APP_API_BASE_URL + `personal/templates/${templateId}`
      );
    }
  };

  const urlToStore = () => {
    const campaignId = campaignData.currentABTestCampaign == 'A' ? campaignData.campaignId : campaignData.campaingABTestData.campaignABTestId;
    if (userData.userFlow === "createCampaign") {
      return (
        process.env.REACT_APP_API_BASE_URL +
        `personal/campaigns/${campaignId}`
      );
    } else {
      if (!isContentFlag) {
        return process.env.REACT_APP_API_BASE_URL + `personal/templates`;
      }
    }
  };

  Editor.defaultProps = {
    id: "grapesjs-react-editor",
    isOffer: isOffer,
    presetType:
      templateType === "email" || campaignData.campaignType === "email"
        ? "grapesjsMJML"
        : "webpage",
    plugins: [],
    blocks: [],
    blockManager: {},
    storageManager: {
      id: "grapesjs-react-editor",
      type: "remote",
      autosave: true,
      autoload: true,
      stepsBeforeSave: 1, // If autosave enabled, indicates how many steps (general changes to structure), need to be done before save. Useful with remoteStorage to reduce remote calls
      urlLoad: urlLoad,
      urlStore: urlStore,
      params:
        userData.userFlow === "createCampaign"
          ? {
            templateId: campaignData.campignTemplateId,
          }
          : {
            id: templateParameterId,
            name: templateName,
            baseTemplateId: baseTemplateId,
            description: templateDescription,
            isDraft: 0,
            type: templateType, //Email or PC
            layoutType: "userTemplate",
            category: "test",
            subCategory: "test",
          },
      headers: { Authorization: token },
      contentTypeJson: true,
      onComplete(jqXHR) {
        if (userData.userFlow !== "createCampaign") {
          if ("name" in jqXHR) {


          } else {

            dispatch(setTemplateId(jqXHR.id));
            dispatch(setTemplateParameterId(jqXHR.id));
          }
        } else {
            ///TODO
            postCampaignData({isAdvisorConnect:false, widgetType:null},campaignData.campaignId).then(d=>{
              console.log(d)
              dispatch(setCampaignIsAdvisor(false));
              dispatch(setCategory(d.category));


              
            }).catch((e)=>{ console.log(e)})

            
        }
      },
    },
    styleManager: {},
    width: "auto",
    height: "100vh",
    components: [],
  };

  const urlToSelectTemplate = () => {
    userData.userFlow == "createCampaign"
      ? props.history.push(`/admin/campaign/create`)
      : props.history.push(`/admin/templates/all_templates`);
  };
  const urlToContentPage = () => {
    props.history.push(`/admin/templates/content`);
  };

  return (
    <div ref={ref}>

      <div class="alert alert-success" id="mydiv" style={{ display: "inline" , visibility:"hidden" }}>
        Personalization field is copied
      </div>

      <div id="vestorlyWindow" style={{ display: "none" }}>
        <SelectArticles block={getCurrentBlock} type={getType} />
      </div>
      <div className="createtemplates">
        <div style={{ position: "relative" }}>
            {
            < Editor
              nexturl={() => urlToSelectTemplate()}
          toContent={() => urlToContentPage()}
          from_campaign={
            userData.userFlow === "createCampaign" ? true : false
          }
          Dropdownvalues={dropdownvalues}
          userFlow={userData.userFlow}
          templateType={templateType}
          campaignType={campaignData.campaignType}
          templateParameterId={templateParameterId}
            />
          }
        </div>
      </div>
    </div>
  );
}
export default CreateTemplate;
